import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { ContinueWrapper } from './DeclareCredentialsPage.styles';

import { useCheckFlag } from '@speeki/feature-flags';
import { Button } from '@speeki/global-ui-components';
import { IconManager } from '@speeki/icons';

import { Card } from '@components/molecules/Card/Card';
import {
    CHANGE_PERSONAL_INFO_FORM_ID,
    ChangePersonalInfoForm,
} from '@components/organisms/ChangePersonalInfoForm/ChangePersonalInfoForm';
import {
    PERSONAL_INFO_FORM_ID,
    PersonalInfoForm,
} from '@components/organisms/PersonalInfoForm/PersonalInfoForm';
import { ColumnsLayout } from '@components/templates/ColumnsLayout/ColumnsLayout';

import { RespondentTypeDocument } from '@graphql/generated/graphql';

import { getPath } from '@services/RouteService/paths';

import { useQuery } from '@apollo/client';
import { LoginBanner } from '@domains/auth/molecules/LoginBanner/LoginBanner';

export const DeclareCredentialsPage = () => {
    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const isEngagementFeatureEnabled = useCheckFlag(
        'client_admin-stakeholder_engagement-20250312',
    );

    const { t } = useTranslation();
    const { disclosureUuid } = useParams<{ disclosureUuid: string }>();

    const { data: respondentTypeData } = useQuery(RespondentTypeDocument, {
        skip: !disclosureUuid,
        variables: {
            disclosureUuid: disclosureUuid as string,
        },
    });

    const respondentType = respondentTypeData?.details.respondentType;
    const isOrganization = respondentType === 'ORGANIZATION';

    if (!disclosureUuid)
        return (
            <Navigate
                to={getPath({
                    path: '/disclosure/list',
                })}
            />
        );

    return (
        <ColumnsLayout>
            <Card testId="BG5QQXT">
                <Card.Title>{t('PERSONAL_INFORMATION')}</Card.Title>
                {isEngagementFeatureEnabled ? (
                    <PersonalInfoForm
                        disclosureUuid={disclosureUuid}
                        isOrganization={isOrganization}
                        setIsDisabled={setIsDisabled}
                        setIsLoading={setIsLoading}
                    />
                ) : (
                    <ChangePersonalInfoForm
                        disclosureUuid={disclosureUuid}
                        setIsDisabled={setIsDisabled}
                        setIsLoading={setIsLoading}
                    />
                )}

                <ContinueWrapper>
                    <Button
                        disabled={isDisabled}
                        form={
                            isEngagementFeatureEnabled
                                ? PERSONAL_INFO_FORM_ID
                                : CHANGE_PERSONAL_INFO_FORM_ID
                        }
                        fullWidth
                        isLoading={isLoading}
                        testId="TwMVNnq"
                        type={'submit'}
                        variant={'primary'}
                    >
                        {t('CONTINUE')}
                    </Button>
                </ContinueWrapper>
            </Card>
            <LoginBanner>
                <IconManager icon={'SvgInfo'} size={16} />
                <LoginBanner.Description>
                    {isOrganization
                        ? t('PERSONAL_INFORMATION_TEXT_ORGANISATION')
                        : t('PERSONAL_INFORMATION_TEXT_INDIVIDUAL')}
                </LoginBanner.Description>
            </LoginBanner>
        </ColumnsLayout>
    );
};
